import React from 'react';
import PropTypes from 'prop-types';
import { PlayVideoWrapper } from './PlayVideo.style';
import VideoPlayer from '../../../VideoPlayer/VideoPlayer';

export const videoShape = {
    templateUrl: PropTypes.string,
    duration: PropTypes.string,
    title: PropTypes.string,
    id: PropTypes.string,
    slug: PropTypes.string,
    playbacks: PropTypes.array,
    playerContext: PropTypes.string
};

const PlayVideo = ({
    templateUrl,
    duration,
    title,
    id,
    slug,
    playbacks,
    playerContext
}) => {
    return (
        <PlayVideoWrapper key={`player-video-wrapper-${id}-${playerContext}`}>
            <VideoPlayer
                title={title}
                duration={duration}
                playbackContainerId={`play-video-${id}`}
                id={id}
                showMetaInfo={true}
                templateUrl={templateUrl}
                slug={slug}
                showTitle={false}
                width={'100%'}
                playbacks={playbacks}
                playerContext={playerContext}
            />
        </PlayVideoWrapper>
    );
};

PlayVideo.propTypes = videoShape;

export default PlayVideo;
